<template>
  <div id="app" class="app">
    <!-- <router-view></router-view> -->
    <router-view v-slot="{ Component }">
      <keep-alive :include="cachedViews">
        <component :is="Component" :key="$route.fullPath" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {

  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    }
  }
}
</script>

<style lang="scss" >
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.app{
  width: 100%;
  height: 100%;

}
</style>
